import React from "react"

export interface MapContextInterface {
    map: google.maps.Map
}

/** Context to pass down the map instance to the OverlayViewContainer component */
const MapContext = React.createContext<MapContextInterface | null>(null);

export default MapContext;